import { Component } from '@angular/core';
import { Button } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { MyAccountComponent } from 'app/my-account/pages/my-account/my-account.component';
import { AuthService } from 'app/auth/services/auth.service';

@Component({
  selector: 'app-navbar',
  imports: [Button],
  providers: [DialogService],
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {

  constructor(
    private dialogService: DialogService,
    private authService: AuthService
  ) {}

  openMyAccount() {
    this.dialogService.open(MyAccountComponent, {
      header: 'My Account',
      modal: true,
      width: '600px',
      styleClass: 'comm-dialog max-w-[90vw]'
    });
  }

  logout() {
    this.authService.logout();
  }
}
